import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_FHIRResourceParamValue } from './ModuleFE_FHIRResourceParamValue.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_FHIRResourceParamValue,
    modules: [ModuleFE_FHIRResourceParamValue],
    mapper: item => [item.label ?? item.value],
    placeholder: 'Choose a FHIRResourceParamValue',
    renderer: item => _jsx(_Fragment, { children: item.label ?? item.value })
};
export const DropDown_FHIRResourceParamValue = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_FHIRResourceParamValue,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.label ?? item.value] });
    },
    uiSelector: DropDown_FHIRResourceParamValue.selectable,
});
export const MultiSelect_FHIRResourceParamValue = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map